import { useTranslation } from "@opendash/i18n";
import { Form, FormItemProps } from "antd";
import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { SaveTicketValues } from "../..";
import { useProjects } from "../../../projects";
import { useFieldConfig } from "../../hooks/useFieldConfig";
import { useSaveConfigManager } from "../../hooks/useSaveConfigManager";
import { ProjectInputSelect } from "./project/ProjectInputSelect";

type Props = {
  type: "dropdown";
} & FormItemProps<SaveTicketValues>;

export const ProjectInput = observer((props: Props) => {
  const t = useTranslation();
  const { projects, loading } = useProjects();
  const config = useFieldConfig("project");
  const manager = useSaveConfigManager();

  useEffect(() => {
    if (!manager) return;
    manager.registerPreperation("project");
    if (!loading) {
      manager.markFieldPrepared("project");
    }
  }, [loading, manager]);

  if (config && (config.hidden || !projects.length)) return <></>;

  const label =
    config?.label === "-"
      ? ""
      : config?.label || t("maintenance:ticket.create.project.label");

  return (
    <Form.Item<SaveTicketValues>
      name="project"
      label={label}
      help={config?.help}
      rules={[
        {
          required: config?.required,
          message: t("maintenance:ticket.create.project.error.empty"),
        },
      ]}
      {...props}
    >
      {props.type === "dropdown" && <ProjectInputSelect projects={projects} />}
    </Form.Item>
  );
});
